export const BAR_LINK = 'barLink';
